import { Component, EventEmitter } from '@angular/core';
import {
  FormEntryModel,
  FormIOModel,
  LocationData,
} from '../../formiobuilder/models/formio.model';
import {
  CardInfo,
  CreditPayment,
  CustomerAddress as InvoiceAddress,
  NonCustomerModel,
  SettingsInvoice,
} from '../../shared/models/invoice/invoice.model';
import { CountriesService } from '../../shared/services/countries.service';
import {
  CustomerAddress,
  CustomerCardNumber,
  CustomerPhone,
} from '../../shared/models/customer.model';
import { Orders } from '../../shared/models/invoice/orders.model';
import { CartItem } from '../../shared/models/cart-item.model';
import {
  CommunicationType,
  NewSendReceipt,
  SendReceipt,
} from '../../shared/models/invoice/cash-payment.model';
import { Settings } from '../../shared/models/settings/settings.model';
import { ACHPayment } from '../../shared/models/invoice/ach-payment.model';
import { ActivatedRoute, Router } from '@angular/router';
import { FormIoBuilderService } from '../../formiobuilder/services/formiobuilder.service';
import { InvoiceService } from '../../shared/services/invoice.service';
import { MerchantService } from '../../shared/services/merchant.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CreditPaymentService } from '../../shared/services/creditpayment.service';
import { HeartlandObserverService } from '../../formiobuilder/services/heartland-observer.service';
import { FormObserverService } from '../../formiobuilder/services/form-observer.service';
import { AlertService } from '../../core/alert.service';
import { CustomerManagementService } from '../../shared/services/customer.service';
import { OrderService } from '../../formiobuilder/services/order.service';
import { CartsOrdersCalculator } from '../../shared/libraries/carts-orders-calculator';
import { ACHPaymentService } from '../../shared/services/achpayment.service';
import { ConfirmationService } from '../../formiobuilder/services/confirmations.service';
import { TaxService } from '../../shared/services/tax.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ActionTaken,
  ConfirmationModel,
  Purpose,
} from '../../formiobuilder/models/confirmation.model';
import { FormioUtils } from 'angular-formio';
import { SourceComponent } from '../../shared/models/invoice/payment.model';
import uuid from 'uuid/v4';
import {
  GooglePayment,
  GooglePayCustomerAddress,
} from 'src/app/shared/models/invoice/google-payment.model';
import { GooglePaymentService } from 'src/app/shared/services/googlepayment.service';
import { _ } from 'ag-grid-community';
import { developmentConfig } from 'src/environments/merchant';
import { PaymentConfirmActionComponent } from 'src/app/formioembed/payment-confirm-action/payment-confirm-action.component';
import { findValueByKey } from 'src/app/shared/components/accordion/helpers';
import { PaymentService } from 'src/app/shared/services/payments.service';
declare var window: any;
@Component({
  selector: 'app-formbuilder-embed-base',
  template: ``,
  styleUrls: ['./formbuilder-embed-base.component.scss'],
})
export class FormbuilderEmbedBaseComponent {
  formEntry: FormEntryModel;
  cardInfo: CardInfo;
  customerAddress: InvoiceAddress;
  phonemodel: CustomerPhone;
  cardModel: CustomerCardNumber;
  addressmodel: CustomerAddress;
  cardToken: any;
  submissionData: any;
  paymentFormData: any;
  orderAdjustments: any;
  isValid: boolean = true;
  FormId: string;
  currentForm: any;
  amount: any;
  userId: number = 1;
  terminalId: string = 'MAIN';
  customerId: any;
  invoiceNumber: any;
  options: any;
  submissionCallback: any;
  addressComponentTypes: any[] = [];

  orderData: Orders;
  orderId: any;
  orderItems: CartItem[];
  multiUseToken: any;

  sendReceiptModel: SendReceipt;
  newSendReceiptModel: NewSendReceipt;
  businessInfo: Settings;
  customerAddressId: any;
  customerPhoneId: any;

  busy: boolean = false;
  busy_message: string = 'Loading';
  subTotal: number = 0;
  itemsTotal: number = 0;
  total: number = 0;
  fieldLabels: any = [];
  fieldTypes: any = [];
  isRecaptchaActive: boolean = false;
  recaptchaResponse: any = [];

  isPaymentSystemComponentActive: boolean = false;
  isRegisterCardComponentActive: boolean = false;
  isCardFormActive: boolean = false;
  isAPICall: boolean = false;
  confirmations: any = [];

  achPaymentModel: ACHPayment = new ACHPayment();
  isACHPayment: boolean = false;
  paymentFormInfo: any;

  formData: any = {};
  computingComponents: any = {};
  formIOModel: FormIOModel;
  successEmitter: EventEmitter<any>;

  allComponents: any;
  invoiceSettingModel: SettingsInvoice;
  customerSignature: any;

  // for custom form fields
  isProductfieldActive: boolean = false;
  isSingleProductfieldActive: boolean = false;
  isTermsConditionfieldActive: boolean = false;
  productlist: any = [];
  selectedproductlist: any = [];
  totalselectedproduct: number;
  productFieldlabel: any;
  tc_content: string;
  totalsingleproduct: any;
  isBusinessAddressActive: boolean = false;
  defaultCustomerAddress: string;

  countriesWithCode: any[] = [];
  taxExemptionType: string;
  totalManualTax: number;
  isManualTaxjar: boolean = false;
  isTaxJarComponentActive: boolean;
  taxJarAPIRate: number = 0;
  taxAddressStorage: string; // indicator if the address has been changed then we call the API

  customerCardId: any;
  locationComponentKey: string;
  locationComponentSelectedData: LocationData; // For the location component to fetch the API keys

  isGooglePayment: boolean = false;
  isExistingCustomer: boolean = false;
  transactionId: string;
  formIoComponent: any;
  isRecurringForm: boolean = false;
  captchaToken: string;
  captchaApiKeyId: number;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public formioBuilderService: FormIoBuilderService,
    public invoiceService: InvoiceService,
    public merchantService: MerchantService,
    public dataSanitizer: DomSanitizer,
    public creditService: CreditPaymentService,
    public heartlandObserverService: HeartlandObserverService,
    public formObserverService: FormObserverService,
    public alertService: AlertService,
    public customerApiService: CustomerManagementService,
    public loadCountriesServices: CountriesService,
    public orderService: OrderService,
    public cartsOrdersCalculator: CartsOrdersCalculator,
    public achPaymentService: ACHPaymentService,
    public confirmationsService: ConfirmationService,
    public taxService: TaxService,
    public modalService: NgbModal,
    public googlePayService: GooglePaymentService,
    public paymentService: PaymentService
  ) {
    this.formIOModel = new FormIOModel();
    this.locationComponentSelectedData = new LocationData();
    this.cardModel = new CustomerCardNumber();
    this.cardInfo = new CardInfo();
    this.customerAddress = new InvoiceAddress();
    this.addressmodel = new CustomerAddress();
    this.phonemodel = new CustomerPhone();
    this.orderItems = [];
    this.sendReceiptModel = new SendReceipt();
    this.newSendReceiptModel = new NewSendReceipt();
    this.businessInfo = new Settings();
    this.productlist = [];
    this.selectedproductlist = [];
    this.productFieldlabel = '';

    this.formEntry = new FormEntryModel();
    this.orderData = new Orders();

    this.options = this.getFormOptions();
    this.loadBusinessInfo();
    this.loadCountriesCode();
    this.loadSettings();

    this.activatedRoute.params.subscribe((params) => {
      this.FormId = params['id'];
      if (this.FormId) {
        this.loadData(this.FormId);
      }
    });

    this.heartlandObserverService.cast.subscribe((tokenData) => {
      this.paymentFormData = tokenData;
    });

    this.heartlandObserverService.castamount.subscribe((amount) => {
      this.amount = amount;
    });

    this.heartlandObserverService.castPaymentFormInfo.subscribe(
      (paymentFormInfo) => {
        this.paymentFormInfo = paymentFormInfo;
      }
    );
  }

  loadBusinessInfo() {
    this.merchantService.getMerchant('1').subscribe((response: any) => {
      if (response) {
        this.businessInfo = response;
        this.formObserverService.updateBusinessData(this.businessInfo);
        window.pendo.initialize({
          visitor: {
            id: findValueByKey('localAccountId'),
            pmp_role: 'Customer',
            pmp_IsCustomerSupport: 0,
          },
          account: {
            id: 'pmp_' + this.businessInfo.HeartlandMerchantID,
            pmp_name: this.businessInfo.BusinessName,
            pmp_package: this.businessInfo.Package,
            pmp_subdomain: this.subdomain(),
            pmp_MCC: this.businessInfo.MCCCode,
          },
        });
      }
    });
  }

  subdomain() {
    // Get the full hostname
    var fullHostname = window.location.hostname;

    // Split the hostname by periods
    var hostnameParts = fullHostname.split('.');

    // If there are more than two parts (e.g., 'subdomain.example.com')
    if (hostnameParts.length > 2) {
      // Get the first part as the subdomain
      var subdomain = hostnameParts[0];
      return subdomain;
    } else {
      return developmentConfig.merchant;
    }
  }

  loadSettings() {
    this.invoiceService
      .getSettingsInvoice()
      .subscribe((res: SettingsInvoice) => {
        this.invoiceSettingModel = res || new SettingsInvoice();
      });
  }

  preprocessSubmission() {
    this.scrollToTop();

    if (this.isRegisterCardComponentActive) {
      this.startSaving();
    } else {
      this.checkForSignatureVerification();
    }
  }

  checkForSignatureVerification() {
    if (
      this.invoiceSettingModel.requireCustomerSignOrPasswordOnPayment &&
      this.isPaymentSystemComponentActive
    ) {
      let signDiag = this.modalService.open(PaymentConfirmActionComponent, {
        size: 'lg',
        backdrop: 'static',
      });
      signDiag.componentInstance.hideUserPassword = true;
      signDiag.componentInstance.showModalOnRight = false;
      signDiag.result.then((res) => {
        if (res) {
          if (res.signUrl) {
            this.customerSignature = res.signUrl;
          } else {
            this.customerSignature = null;
          }
          this.startSaving();
        } else {
          this.busy = false;
          this.isAPICall = false;
          this.submissionCallback(
            {
              message: 'Something went wrong',
              component: null,
            },
            null
          );
        }
      });
    } else {
      this.startSaving();
    }
  }

  startSaving() {
    // If authorization component is active
    if (this.isRegisterCardComponentActive) {
      this.observeHeartlandResponse(this.submissionData);
      return;
    }

    if (!this.isPaymentSystemComponentActive) {
      this.saveForm();
      return;
    }

    this.isACHPayment = false;
    this.isGooglePayment = false;
    // Credit Card
    if (
      this.submissionData.heartlandpayment &&
      this.submissionData.heartlandpayment.paymentType === 'credit_card'
    ) {
      this.observeHeartlandResponse(this.submissionData);
    }
    // ACH
    else if (
      this.submissionData.heartlandpayment &&
      this.submissionData.heartlandpayment.paymentType === 'ach'
    ) {
      this.isACHPayment = true;
      this.paymentFormData =
        this.submissionData.heartlandpayment.paymentFormData;
      this.validateACH(this.submissionData);
    }
    // Google Pay
    else if (
      this.submissionData.heartlandpayment &&
      this.submissionData.heartlandpayment.paymentType === 'google_pay'
    ) {
      this.isGooglePayment = true;
      this.paymentFormData =
        this.submissionData.heartlandpayment.paymentFormData;
      this.saveForm();
    } else {
      this.alertError({
        title: 'Submission Error',
        text: 'Please select a Payment type.',
      });
    }
  }

  validateACH(submissionData: any) {
    const achFormData = submissionData.heartlandpayment;
    const achModel = submissionData.heartlandpayment.achModel;
    this.achPaymentModel = achModel;

    if (achFormData.error) {
      this.alertError({ title: 'Error', text: achFormData.error_message });
      return;
    }

    if (achFormData.warning) {
      this.alertService
        .alertWarning({ title: 'Warning', text: achFormData.warning_message })
        .then(() => {
          this.saveForm();
        });
    } else {
      this.saveForm();
    }
  }

  alertError(error) {
    const confirmation = this.generateResponse(Purpose.OnFailure, error.text);
    this.busy = false;
    if (this.isAPICall && confirmation) {
      if (confirmation.message) {
        this.alertService.alertError({
          title: error.title,
          text: confirmation.message,
        });
      }

      if (confirmation.redirectUrl) {
        (window as any).top.location.href = confirmation.redirectUrl;
      }
    } else {
      this.alertService.alertError({ title: error.title, text: error.text });
    }

    this.isAPICall = false;
    this.submissionCallback(
      {
        message: 'Something went wrong',
        component: null,
      },
      null
    );
  }

  saveForm() {
    let newSubmission = this.sanitiseSubmissionData(this.submissionData);
    newSubmission = {
      ...newSubmission,
      fieldLabels: this.fieldLabels,
      fieldTypes: this.fieldTypes,
      addressComponents: this.addressComponentTypes,
    };

    this.formEntry.FormID = this.FormId;
    this.formEntry.Data = newSubmission;

    // Set the data of the selected location
    this.setSelectedLocationData();
    if (
      this.isTermsConditionfieldActive &&
      (!newSubmission.termscondition || newSubmission.termscondition == 'false')
    ) {
      this.alertError({
        title: 'Error',
        text: 'Please Agree to Terms and Conditions..',
      });
      return false;
    }
    // Set Customer address
    if (
      this.isBusinessAddressActive == true &&
      this.isPaymentSystemComponentActive &&
      this.defaultCustomerAddress == 'address_two'
    ) {
      this.customerAddress.Country =
        this.submissionData && this.submissionData.countries_2;
      this.customerAddress.City =
        this.submissionData && this.submissionData.city_2;
      this.customerAddress.State =
        this.submissionData &&
        (this.submissionData.states_2 || this.submissionData.states1_2);
      this.customerAddress.PostalCode =
        this.submissionData && this.submissionData.postcode_2;
      this.customerAddress.StreetAddress1 =
        this.submissionData && this.submissionData.street_2;
      this.customerAddress.StreetAddress2 =
        this.submissionData && this.submissionData.address2_2;
    } else {
      this.customerAddress.City =
        this.submissionData && this.submissionData.city;
      this.customerAddress.Country =
        this.submissionData && this.submissionData.countries;
      this.customerAddress.State =
        this.submissionData &&
        (this.submissionData.states || this.submissionData.states1);
      this.customerAddress.PostalCode =
        this.submissionData &&
        (this.submissionData.postcode || this.submissionData.postcode1);
      this.customerAddress.StreetAddress1 =
        this.submissionData && this.submissionData.street;
      this.customerAddress.StreetAddress2 =
        this.submissionData && this.submissionData.address2;
    }

    this.isAPICall = true;
    this.formioBuilderService.postUserDataEmbedForm(this.formEntry).subscribe(
      (res: number) => {
        if (res) {
          if (!this.formEntry.Id) this.formEntry.Id = res;
          if (
            (this.isPaymentSystemComponentActive &&
              (this.paymentFormData ||
                this.isACHPayment ||
                this.isGooglePayment)) ||
            this.isRegisterCardComponentActive
          ) {
            this.cardToken = this.paymentFormData;
            if (!this.isGooglePayment) {
              this.formEntry.Data = {
                ...this.formEntry.Data,
                customerInfo: {
                  firstName:
                    this.paymentFormData?.customerData?.firstName ||
                    this.submissionData.firstname,
                  lastName:
                    this.paymentFormData?.customerData?.lastName ||
                    this.submissionData.lastname,
                  streetAddress: `${this.customerAddress.StreetAddress1}${
                    this.customerAddress.StreetAddress2 ? '\n' : ''
                  }${this.customerAddress.StreetAddress2 || ''}`,
                  city: this.customerAddress.City,
                  state: this.customerAddress.State,
                  zipcode: this.customerAddress.PostalCode,
                  country: this.customerAddress.Country,
                  phoneNumber:
                    this.paymentFormData?.customerData?.phone ||
                    this.submissionData.phoneNumber,
                  emailAddress:
                    this.paymentFormData?.customerData?.email ||
                    this.submissionData.emailaddress,
                },
              };
            }

            if (this.isRegisterCardComponentActive) {
              this.authorizeAndSaveCard();
            } else {
              this.createOrder();
            }
          } else {
            this.busy = false;
            this.alertSuccess({
              title: 'Success!',
              text: 'Form has been successfully submitted!',
            });
          }
        }
      },
      (err) => {
        this.alertError({ title: 'Unable to save Form', text: err.error });
      }
    );
  }

  setSelectedLocationData() {
    if (this.locationComponentKey) {
      this.locationComponentSelectedData.Id =
        this.formEntry.Data[this.locationComponentKey].Id;
      this.locationComponentSelectedData.Name =
        this.formEntry.Data[this.locationComponentKey].BranchName;
    }
  }

  authorizeAndSaveCard() {
    // Verify the card first
    this.verifyCard();
  }

  createOrder() {
    const cartItem = new CartItem();
    const orderItems = [];
    cartItem.Item.Id = uuid();
    cartItem.Item.ItemName = 'Payment Form';
    cartItem.Item.RecentPrice = this.itemsTotal;
    cartItem.Price = this.itemsTotal;
    cartItem.Qty = 1;
    orderItems.push(cartItem);

    this.orderData = this.cartsOrdersCalculator.CartDataToOrders(orderItems);
    this.orderData.orderId = this.orderId;
    this.orderData.invoiceNumber = this.invoiceNumber;
    this.orderData.customerId = this.customerId;
    this.orderData.terminalId = this.terminalId;
    this.orderData.createdBy = this.userId;
    this.orderData.orderDate = new Date();

    this.orderService.saveOrder(this.orderData).subscribe(
      (res: any) => {
        if (res) {
          this.orderId = res.OrderId;
          this.orderData.orderId = res.OrderId;
          this.getOrCreateCustomer();
        } else {
          this.alertError({
            title: 'Saving order error!',
            text: 'Unable to Save order.',
          });
        }
      },
      (error: any) => {
        this.alertError({
          title: 'Saving order error!',
          text: 'Unable to Save order.',
        });
      }
    );
  }

  /**
   * Sanitise Submission Data before posting/save to API
   */
  sanitiseSubmissionData(objectData: any) {
    // Exclude Location as this is a hardcoded selection
    const selectComponents = this.allComponents.filter((component) => {
      return (
        component.type === 'select' &&
        component.componentType !== 'location' &&
        component.componentType !== 'recurringPayment'
      );
    });

    if (
      this.isSingleProductfieldActive == true &&
      !objectData.hasOwnProperty('singleproduct')
    ) {
      objectData.singleproduct = this.totalsingleproduct;
      this.isSingleProductfieldActive = false;
    }

    for (let key in objectData) {
      // let newDataObject = this.dataSanitizer.sanitize( SecurityContext.HTML, objectData[key]);
      let newDataObject = FormioUtils.sanitize(String(objectData[key]), {});
      if (objectData[key] instanceof Object) {
        objectData[key] = this.sanitiseSubmissionData(objectData[key]);
      } else {
        objectData[key] = newDataObject;
      }

      const selectComponent = selectComponents.filter((component) => {
        return component.key === key;
      });

      if (selectComponent.length > 0) {
        objectData[key] =
          typeof objectData[key] === 'object'
            ? objectData[key].join(',')
            : objectData[key];
      }

      if (key === 'subtotal') {
        objectData[key] = this.subTotal;
      }
      if (key === 'total') {
        objectData[key] = this.total;
      }

      if (key === 'heartlandpayment') {
        const hpsData = { ...objectData[key] };
        if (objectData[key].paymentType == 'credit_card') {
          objectData[key] = { ...hpsData, ...objectData[key].customerData };
          delete objectData[key]['customerData'];
        } else if (objectData[key].paymentType == 'ach') {
          objectData[key] = {
            ...hpsData,
            ...objectData[key].paymentFormData.customerData,
            amount: objectData[key].paymentFormData.amount,
          };

          delete objectData[key]['paymentFormData'];
          delete objectData[key]['achModel'];
          delete objectData[key]['error'];
          delete objectData[key]['error_message'];
          delete objectData[key]['warning'];
          delete objectData[key]['warning_message'];
        }
      }
    }
    return objectData;
  }

  setFieldLabels() {
    const tempAllComponents = this.allComponents;
    let filteredAddressComponents = [];

    // for multiple address forms
    const addressComponents = this.allComponents.filter((addresscomponent) => {
      return addresscomponent.componentType === 'customaddress';
    });

    if (addressComponents.length > 0) {
      for (let address in addressComponents) {
        for (let field of addressComponents[address].components) {
          if (field.componentType == 'customaddress') {
            this.checkForNestedAddress(field);
          }
        }
        this.addressComponentTypes.push({
          title: addressComponents[address]['title'],
          fieldLabels: addressComponents[address]['components'].map((item) =>
            !item.hasOwnProperty('components') ? item.key : ''
          ),
        });
      }
    }

    // for new billing address forms
    const billingAddressComponents = this.allComponents.filter(
      (billingAddress) => {
        return billingAddress.componentType === 'custom_billing_address';
      }
    );

    if (billingAddressComponents.length > 0) {
      this.isBusinessAddressActive = true;
      if (
        billingAddressComponents[0].customOptions &&
        billingAddressComponents[0].customOptions.customerAddress
      ) {
        this.defaultCustomerAddress =
          billingAddressComponents[0].customOptions.customerAddress;
      }
      for (let address in billingAddressComponents) {
        for (let field of billingAddressComponents[address].components) {
          if (field.componentType == 'customaddress') {
            this.checkForNestedAddress(field);
          }
        }
        this.addressComponentTypes.push({
          title: billingAddressComponents[address]['legend'],
          fieldLabels: billingAddressComponents[address]['components'].map(
            (item) => (!item.hasOwnProperty('components') ? item.key : '')
          ),
        });
      }
    }

    this.allComponents.map((component) => {
      if (component.componentType === 'customaddress') {
        // Street
        const street = tempAllComponents.filter((addressComponent) => {
          return (
            filteredAddressComponents.indexOf(addressComponent.key) === -1 &&
            addressComponent.componentType &&
            addressComponent.componentType.indexOf('customaddress.street') !==
              -1
          );
        })[0];
        filteredAddressComponents.push(street.key);
        this.fieldLabels = {
          ...this.fieldLabels,
          [street.key]: `${component.title || component.label} (Street)`,
        };

        // Address line 2
        const address2 = tempAllComponents.filter((addressComponent) => {
          return (
            filteredAddressComponents.indexOf(addressComponent.key) === -1 &&
            addressComponent.componentType &&
            addressComponent.componentType.indexOf('customaddress.address2') !==
              -1
          );
        })[0];
        filteredAddressComponents.push(address2.key);
        this.fieldLabels = {
          ...this.fieldLabels,
          [address2.key]: `${
            component.title || component.label
          } (Address Line 2)`,
        };

        // City
        const city = tempAllComponents.filter((addressComponent) => {
          return (
            filteredAddressComponents.indexOf(addressComponent.key) === -1 &&
            addressComponent.componentType &&
            addressComponent.componentType.indexOf('customaddress.city') !== -1
          );
        })[0];
        filteredAddressComponents.push(city.key);
        this.fieldLabels = {
          ...this.fieldLabels,
          [city.key]: `${component.title || component.label} (City)`,
        };

        // State
        const state = tempAllComponents.filter((addressComponent) => {
          return (
            filteredAddressComponents.indexOf(addressComponent.key) === -1 &&
            addressComponent.componentType &&
            addressComponent.componentType.indexOf('customaddress.state') !== -1
          );
        })[0];

        // State 1
        const state1 = tempAllComponents.filter((addressComponent) => {
          return (
            filteredAddressComponents.indexOf(addressComponent.key) === -1 &&
            addressComponent.componentType &&
            addressComponent.componentType.indexOf('customaddress.state') !== -1
          );
        })[1];

        filteredAddressComponents.push(state.key);
        this.fieldLabels = {
          ...this.fieldLabels,
          [state.key]: `${component.title || component.label} (State)`,
        };

        filteredAddressComponents.push(state1.key);
        this.fieldLabels = {
          ...this.fieldLabels,
          [state1.key]: `${component.title || component.label} (State)`,
        };
        /*
        // Postcode
        const postcode = tempAllComponents.filter(addressComponent => {
          return filteredAddressComponents.indexOf(addressComponent.key) === -1 && addressComponent.componentType &&  addressComponent.componentType.indexOf('customaddress.postcode') !== -1;
        })[0];

        // Postcode 1
        const postcode1 = tempAllComponents.filter(addressComponent => {
          return filteredAddressComponents.indexOf(addressComponent.key) === -1 && addressComponent.componentType &&  addressComponent.componentType.indexOf('customaddress.postcode') !== -1;
        })[1];

        filteredAddressComponents.push(postcode.key);
        this.fieldLabels = { ...this.fieldLabels, [postcode.key]:  `${component.title || component.label} (Postcode)`};

        filteredAddressComponents.push(postcode1.key);
        this.fieldLabels = { ...this.fieldLabels, [postcode1.key]:  `${component.title || component.label} (Postcode)`};
*/
        // Country
        const countries = tempAllComponents.filter((addressComponent) => {
          return (
            filteredAddressComponents.indexOf(addressComponent.key) === -1 &&
            addressComponent.componentType &&
            addressComponent.componentType.indexOf(
              'customaddress.countries'
            ) !== -1
          );
        })[0];
        filteredAddressComponents.push(countries.key);
        this.fieldLabels = {
          ...this.fieldLabels,
          [countries.key]: `${component.title || component.label} (Country)`,
        };
      } else if (component.type === 'subscriptionPlans') {
        this.fieldLabels = {
          ...this.fieldLabels,
          'subscription.PlanCode': 'Subscription (Plan Code)',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          'subscription.PlanName': 'Subscription (Plan Name)',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          'subscription.PlanPrice': 'Subscription (Plan Price)',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          'heartlandpayment.amount': 'Payment Form (Total)',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          'heartlandpayment.paymentType': 'Payment Form (Payment Type)',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          'heartlandpayment.firstName': 'Payment Form (First Name)',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          'heartlandpayment.lastName': 'Payment Form (Last Name)',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          'heartlandpayment.email': 'Payment Form (Email Address)',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          'heartlandpayment.phone': 'Payment Form (Contact Number)',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          'heartlandpayment.saveCard':
            'Payment Form (Save Card / Create Account)',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          'subscription.PlanDescription': 'Subscription (Description)',
        };
        this.fieldLabels = { ...this.fieldLabels, street: 'Street Address' };
        this.fieldLabels = { ...this.fieldLabels, address2: 'Address Line 2' };
        this.fieldLabels = { ...this.fieldLabels, city: 'City' };
        this.fieldLabels = { ...this.fieldLabels, countries: 'Country' };
        this.fieldLabels = { ...this.fieldLabels, states: 'State' };
        this.fieldLabels = {
          ...this.fieldLabels,
          postcode: 'Zip / Postal Code',
        };

        this.fieldTypes = {
          ...this.fieldTypes,
          'heartlandpayment.amount': 'currency',
        };
      } else if (component.type === 'heartlandpayment') {
        this.fieldLabels = {
          ...this.fieldLabels,
          [`${component.key}.amount`]: 'Payment Form (Total)',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          [`${component.key}.paymentType`]: 'Payment Form (Payment Type)',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          [`${component.key}.firstName`]: 'Payment Form (First Name)',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          [`${component.key}.lastName`]: 'Payment Form (Last Name)',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          [`${component.key}.email`]: 'Payment Form (Email Address)',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          [`${component.key}.phone`]: 'Payment Form (Contact Number)',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          [`${component.key}.saveCard`]:
            'Payment Form (Save Card / Create Account)',
        };
        this.fieldTypes = {
          ...this.fieldTypes,
          [`${component.key}.amount`]: 'currency',
        };
      } else if (component.type === 'termscondition') {
        this.fieldLabels = {
          ...this.fieldLabels,
          [component.key]: 'Terms and Condition',
        };
      } else if (component.type === 'productfield') {
        const productTitle = component.data && component.data.label;
        this.fieldLabels = {
          ...this.fieldLabels,
          [`${component.key}.label`]: 'Product Select Title',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          [`${component.key}.amount`]: `${productTitle} total`,
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          [`${component.key}.selectedProducts`]: `Selected ${productTitle}`,
        };

        this.fieldTypes = {
          ...this.fieldTypes,
          [`${component.key}.amount`]: 'currency',
        };
      } else if (component.type === 'singleproduct') {
        const productTitle = component.data && component.data.label;
        this.fieldLabels = {
          ...this.fieldLabels,
          [`${component.key}.label`]: 'Item',
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          [`${component.key}.productName`]: `Product Name`,
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          [`${component.key}.productPrice`]: `Price`,
        };
        this.fieldLabels = {
          ...this.fieldLabels,
          [`${component.key}.productQuantity`]: `Quantity`,
        };
        this.fieldTypes = {
          ...this.fieldTypes,
          [`${component.key}.productSubtotal`]: 'Product Subtotal',
        };
      } else {
        if (filteredAddressComponents.indexOf(component.key) === -1) {
          const componentKey = component.key;
          const componentValue = component.title || component.label;
          this.fieldLabels = {
            ...this.fieldLabels,
            [componentKey]: componentValue,
          };

          if (component.type == 'currency') {
            this.fieldTypes = {
              ...this.fieldTypes,
              [component.key]: 'currency',
            };
          }
        }
      }
    });
  }

  // for nested address
  checkForNestedAddress(address) {
    this.addressComponentTypes.push({
      title: address.title ? address.title : address.legend,
      fieldLabels: address.components.map((item) =>
        !item.hasOwnProperty('components') ? item.key : ''
      ),
    });
  }

  // Create Customer and Card
  createCustomer() {
    const customerData = {
      Id: this.customerId,
      FirstName:
        this.paymentFormData?.customerData?.firstName ||
        this.submissionData.firstname,
      LastName:
        this.paymentFormData?.customerData?.lastName ||
        this.submissionData.lastname,
      EmailAddress:
        this.paymentFormData?.customerData?.email ||
        this.submissionData.emailaddress,
      LocationId: this.paymentFormData?.locationData?.Id,
      CustomerTypeId: 1,
      IsDeleted: false,
      MembershipNumber: 'TempNumber',
      MembershipStartDate: new Date(),
      IsDeactivated: false,
      CreatedBy: this.userId,
      CreatedDate: new Date(),
      UpdatedBy: null,
      UpdatedDate: null,
    };

    if (!this.isExistingCustomer) {
      this.customerApiService.saveCustomer(customerData).subscribe(
        (res) => {
          if (res) {
            if (!this.customerId) {
              this.customerId = res;
            }
            this.addAddress(this.customerId);
            this.addPhone(this.customerId, null);
          }
        },
        (err) => {
          this.alertError({
            title: 'Creating Customer failed',
            text: err.error,
          });
        }
      );
    } else {
      this.addAddress(this.customerId);
      this.addPhone(this.customerId, null);
    }
  }

  addAddress(customerId: any) {
    this.addressmodel.Id = this.customerAddressId;
    this.addressmodel.AddressType = 1;
    this.addressmodel.CustomerId = customerId;
    this.addressmodel.ContactPersonId = null;
    this.addressmodel.IsDefault = true;
    this.addressmodel.CreatedBy = 1;
    this.addressmodel.UpdatedBy = null;
    this.addressmodel.IsDeleted = false;

    let addressFormCountry =
      this.submissionData && this.submissionData.countries;

    if (
      this.isBusinessAddressActive == true &&
      this.isPaymentSystemComponentActive &&
      this.defaultCustomerAddress == 'address_two'
    ) {
      addressFormCountry =
        this.submissionData && this.submissionData.countries_2;
    }

    const selectedCountry = this.loadCountriesServices.countrieslists.find(
      (country) => {
        // @ts-ignore
        return country.CountryCode === addressFormCountry;
      }
    );

    const selectedCountryByName =
      this.loadCountriesServices.countrieslists.find((country) => {
        // @ts-ignore
        return country.CountryName === addressFormCountry;
      });

    if (!selectedCountry && !selectedCountryByName) {
      this.alertError({
        title: 'Form Error',
        text: "The country you've set was not found on our database. Please use the country dropdown to set the correct country value.",
      });
      return;
    }

    if (
      this.isBusinessAddressActive == true &&
      this.isPaymentSystemComponentActive &&
      this.defaultCustomerAddress == 'address_two'
    ) {
      this.addressmodel.CountryId =
        // @ts-ignore
        (selectedCountry && selectedCountry.Id) ||
        // @ts-ignore
        (selectedCountryByName && selectedCountryByName.Id);
      this.addressmodel.City =
        this.submissionData && this.submissionData.city_2;
      this.addressmodel.State =
        this.submissionData &&
        (this.submissionData.states_2 || this.submissionData.states1_2);
      this.addressmodel.ZipCode =
        this.submissionData && this.submissionData.postcode_2;
      this.addressmodel.StreetAddress =
        this.submissionData && this.submissionData.street_2;
      this.addressmodel.Address2 =
        this.submissionData && this.submissionData.address2_2;
    } else {
      // @ts-ignore
      this.addressmodel.CountryId =
        // @ts-ignore
        (selectedCountry && selectedCountry.Id) ||
        // @ts-ignore
        (selectedCountryByName && selectedCountryByName.Id);
      this.addressmodel.City = this.submissionData && this.submissionData.city;
      this.addressmodel.State =
        this.submissionData && this.submissionData.states;
      this.addressmodel.ZipCode =
        this.submissionData &&
        (this.submissionData.postcode || this.submissionData.postcode1);
      this.addressmodel.StreetAddress =
        this.submissionData && this.submissionData.street;
      this.addressmodel.Address2 =
        this.submissionData && this.submissionData.address2;
    }

    this.customerApiService.addAddress(this.addressmodel).subscribe(
      (res: any) => {
        if (res) {
          if (!this.customerAddressId) {
            this.customerAddressId = res.CustomerAddress.Id;
          }

          if (this.isRegisterCardComponentActive) {
            this.saveCustomerCard();
          } else {
            this.createInvoice();
          }
        }
      },
      (err) => {
        this.alertError({ title: 'Saving Address failed', text: err.error });
      }
    );
  }

  addPhone(customerId: any, contactpersonId: any) {
    this.phonemodel.Id = this.customerPhoneId;
    this.phonemodel.CustomerId = customerId;
    this.phonemodel.ContactPersonId = contactpersonId;
    this.phonemodel.IsDefault = true;
    this.phonemodel.CreatedBy = 1;
    this.phonemodel.UpdatedBy = null;
    this.phonemodel.IsDeleted = false;
    this.phonemodel.PhoneType = 1;
    this.phonemodel.PhoneNumber =
      this.paymentFormData?.customerData?.phone ||
      this.submissionData.phoneNumber;
    if (this.phonemodel.PhoneNumber) {
      this.customerApiService.addPhone(this.phonemodel).subscribe(
        (res: any) => {
          if (res) {
            if (!this.customerPhoneId) {
              this.customerPhoneId = res.CustomerPhone.Id;
            }
          }
        },
        (err) => {
          this.alertError({ title: 'Saving Contact failed', text: err.error });
        }
      );
    }
  }

  alertSuccess(success) {
    const notificationPayload: any = this.formEntry;

    if (this.locationComponentKey && this.locationComponentSelectedData) {
      notificationPayload.Data[this.locationComponentKey] =
        this.locationComponentSelectedData.Name;
    }

    const confirmation = this.generateResponse(Purpose.OnSuccess, success.text);
    // Logic of replacing option values for radio, select and checkboxes
    Object.keys(notificationPayload.Data).forEach((key) => {
      const component: any = FormioUtils.getComponent(
        this.formData.components,
        key,
        false
      );
      const value: any = this.formioBuilderService.getDisplayValue(
        component,
        notificationPayload.Data[key]
      );
      notificationPayload.Data[key] = value;
    });

    this.formioBuilderService
      .sendPaymentFormNotification(notificationPayload)
      .subscribe(
        (res) => {
          this.busy = false;
          this.currentForm.emit('submitDone'); //call submitdone event here to stop loading

          if (confirmation) {
            if (confirmation.message) {
              this.alertService
                .alertSuccess({
                  title: success.title,
                  text: confirmation.message,
                })
                .then(() => {
                  this.scrollToTop();
                  (window as any).location.reload();
                });
            }

            if (confirmation.redirectUrl) {
              (window as any).top.location.href = confirmation.redirectUrl;
            }
          }
        },
        (err) => {
          this.alertService
            .alertWarning({
              title: 'Payment Successful<br>Sending Notification failed',
              text: `Your payment was successfully processed<br>
            However, we have encountered problem while saving your card into your account.<br>
            Please contact ${this.businessInfo.BusinessName} for more information`,
            })
            .then(() => {
              if (confirmation) {
                if (confirmation.message) {
                  this.scrollToTop();
                  (window as any).location.reload();
                }

                if (confirmation.redirectUrl) {
                  (window as any).top.location.href = confirmation.redirectUrl;
                }
              } else {
                this.scrollToTop();
                (window as any).location.reload();
              }
            });
        }
      );
  }

  generateResponse(purpose: Purpose, alternativeMessage: string) {
    let redirectUrl: string = '';
    let messages: any = [];
    let messagesContent: string = '';

    const confirmations = this.confirmations.filter(
      (confirmation: ConfirmationModel) => {
        return confirmation.Purpose === purpose;
      }
    );

    confirmations.map((confirmation: ConfirmationModel) => {
      if (confirmation.ActionTaken === ActionTaken.ShowAMessage) {
        messages.push(confirmation.ActionContent);
      } else if (confirmation.ActionTaken === ActionTaken.RedirectToPage) {
        redirectUrl = confirmation.ActionContent;
      }
    });

    if (messages.length > 0) {
      messagesContent = messages.join('\n');
    }

    if (redirectUrl) {
      if (messagesContent) {
        const index = redirectUrl.indexOf('?');

        if (index === -1) {
          redirectUrl += '?';
        }

        if (index !== -1 && index < redirectUrl.length - 1) {
          redirectUrl += '&';
        }

        redirectUrl += 'message=' + messagesContent;
      }

      if (!/^https?:\/\//i.test(redirectUrl)) {
        redirectUrl = '//' + redirectUrl;
      }
    }

    if (!messagesContent) {
      messagesContent = alternativeMessage;
    }
    return {
      message: messagesContent,
      redirectUrl: redirectUrl,
    };
  }

  observeRecaptchaValidation() {
    let self = this;

    setTimeout(function () {
      if (self.recaptchaResponse.hasOwnProperty('configError')) {
        self.alertError({
          title: 'Submission error!',
          text: 'Unable to submit form. A configuration is missing. Please contact your Merchant.',
        });
        return;
      } else if (self.recaptchaResponse.hasOwnProperty('token')) {
        self.captchaToken = self.recaptchaResponse.token;
        self.captchaApiKeyId = self.recaptchaResponse.apiKeyId;
        self.preprocessSubmission();
      } else {
        self.observeRecaptchaValidation();
      }
    }, 100);
  }

  observeHeartlandResponse(submissionData: any) {
    let self = this;

    setTimeout(function () {
      if (self.paymentFormData.warning) {
        self.submissionCallback(
          {
            message: 'Something went wrong',
            component: null,
          },
          null
        );

        self.alertService
          .alertWarning({
            title: 'Warning',
            text: self.paymentFormData.warning_message,
          })
          .then(() => {
            const tokenData = self.paymentFormData;
            tokenData.warning = false;

            self.heartlandObserverService.updateTokenData(tokenData);
            self.observeHeartlandResponse(submissionData);
          });
      } else if (self.paymentFormData.error) {
        self.alertError({
          title: 'There was an error',
          text: self.paymentFormData.error_message,
        });
        self.heartlandObserverService.updateTokenData({
          error: false,
          error_message: '',
        });
      } else if (
        self.paymentFormData.card_type == 'amex' &&
        !self.submissionData.postcode &&
        !self.submissionData.postcode1
      ) {
        self.alertError({
          text: 'An American Express card requires a zip code for verification.',
        });
        self.heartlandObserverService.updateTokenData({
          error: false,
          error_message: '',
        });
      } else if (!self.paymentFormData.token) {
        self.observeHeartlandResponse(submissionData);
      } else {
        self.saveForm();
        return;
      }
    }, 100);
  }

  saveCustomerCard() {}

  // Create Invoice and Transaction
  createInvoice() {
    let commercialData: any = {};

    if (this.computingComponents.commercialLineItems.length > 0) {
      commercialData.customerId = this.customerId;
      commercialData.items = [];
      this.computingComponents.commercialLineItems.forEach((key: string) => {
        commercialData.items.push(this.submissionData[key]);
      });
    }

    this.invoiceService
      .saveInvoice(
        this.orderId,
        'PaymentForm',
        this.invoiceNumber,
        commercialData
      )
      .subscribe(
        (res: any) => {
          if (res) {
            this.invoiceNumber = res.invoiceNumber;
            this.orderData.invoiceNumber = res.invoiceNumber;
            this.formEntry.Data = {
              ...this.formEntry.Data,
              InvoiceNumber: res.invoiceNumber,
            };
            this.formioBuilderService
              .postUserDataEmbedForm(this.formEntry)
              .subscribe(
                (res: number) => {
                  console.log(res);
                },
                (err) => {
                  this.alertError({
                    title: 'Unable to save Form',
                    text: err.error,
                  });
                }
              );

            this.setOrderAdjustments();

            if (this.customerId) {
              this.invoiceService
                .upsertretailinvoicecustomer(
                  this.invoiceNumber,
                  this.customerId
                )
                .subscribe(
                  (res: any) => {
                    if (this.isACHPayment) {
                      this.processACHPayment();
                    } else if (this.isGooglePayment) {
                      this.processGooglePayment();
                    } else {
                      if (this.isRecurringForm) {
                        this.verifyCard();
                      } else {
                        this.processCardPayment();
                      }
                    }
                  },
                  (err) => {
                    this.alertError({
                      title:
                        'Unable to assign Customer. Please contact the Merchant administrator',
                      text: err.error,
                    });
                  }
                );
            } else {
              if (this.isGooglePayment) {
                this.processGooglePayment();
              } else {
                const payload = new NonCustomerModel();
                payload.invoiceNumber = this.invoiceNumber;
                payload.firstName =
                  this.paymentFormData?.customerData?.firstName;
                payload.lastName = this.paymentFormData?.customerData?.lastName;
                payload.receiptEmail =
                  this.paymentFormData?.customerData?.email;
                this.invoiceService
                  .saveNonCustomerInvoiceDetails(payload)
                  .subscribe(
                    (res: any) => {
                      if (this.isACHPayment) {
                        this.processACHPayment();
                      } else {
                        if (this.isRecurringForm) {
                          this.verifyCard();
                        } else {
                          this.processCardPayment();
                        }
                      }
                    },
                    (err) => {
                      this.alertError({
                        title:
                          'Unable to assign Customer. Please contact the Merchant administrator',
                        text: err.error,
                      });
                    }
                  );
              }
            }
          }
        },
        (err) => {
          this.alertError({
            title: 'Unable to create Invoice.',
            text: err.error,
          });
        }
      );
  }

  // Detect if the customer exists or not via email address
  getOrCreateCustomer() {
    this.customerApiService
      .getCustomerByEmailAddress(
        this.paymentFormData?.customerData?.email ||
          this.submissionData.emailaddress
      )
      .subscribe(
        (res: any) => {
          if (res.Result) {
            this.customerId = res.Result.Id;
            this.isExistingCustomer = true;

            if (this.isRegisterCardComponentActive) {
              this.saveCustomerCard();
            } else {
              this.createCustomer();
            }
          } else {
            this.isExistingCustomer = false;
            this.createCustomer();
          }
        },
        (err) => {
          this.alertError({
            title: 'Error while fetching customer records',
            text: err.error,
          });
        }
      );
  }

  // verify Card first before creating transaction - only applicable to Recurring payments and Card authorization only
  verifyCard() {
    this.cardInfo.token = this.cardToken.token;
    this.cardInfo.number = this.cardToken.lastFour;
    this.cardInfo.cardBIN = this.cardToken.cardBIN;
    this.cardInfo.expMonth = this.cardToken.expMonth;
    this.cardInfo.expYear = this.cardToken.expYear;

    const creditData = new CreditPayment();
    creditData.currency = 'USD';
    creditData.cardInfo = this.cardInfo;
    creditData.amount = this.cardToken.amount;
    creditData.invoiceNumber = this.invoiceNumber;
    creditData.terminalId = this.terminalId;
    creditData.customerId = this.customerId;
    creditData.orderId = this.orderId;
    creditData.billingAddress = this.customerAddress;
    creditData.requestMultiUseToken = true;
    creditData.LocationId =
      this.locationComponentSelectedData.Id || this.cardToken.locationData.Id;
    creditData.TransactionSource = SourceComponent.PaymentForms;
    creditData.htoken = this.captchaToken;
    creditData.hApiKeyId = this.captchaApiKeyId;

    if (this.isRecurringForm) {
      creditData.TransactionSource = SourceComponent.RecurringPayment;
    }

    this.creditService.creditVerifyForm(creditData).subscribe(
      (res: any) => {
        // if (res) {
        this.cardModel.Token = res.token;
        // If only autorization
        if (this.isRegisterCardComponentActive) {
          // Primarily detect the customer via email address and get the customerId
          // If it doesn't exists create a new one
          this.getOrCreateCustomer();
        } else {
          this.saveCustomerCard();
        }
        // }
      },
      (err) => {
        const captchaRenderer: any =
          document.getElementById('captchaRenderBtn');

        if (captchaRenderer) captchaRenderer.click();
        this.alertError({
          title: 'Verification failed',
          text: 'We are unable to verify your card. Please contact your administrator.',
        });
      }
    );
  }

  processGooglePayment() {
    const gpayResponse = this.submissionData.heartlandpayment;
    const googlePaymentModel: GooglePayment = new GooglePayment();

    googlePaymentModel.amount = gpayResponse.amount;
    googlePaymentModel.email = gpayResponse.tokenization.email;
    googlePaymentModel.paymentMethodData =
      gpayResponse.tokenization.paymentMethodData;
    googlePaymentModel.paymentMethodData.info.locationId =
      gpayResponse.locationData.Id;
    googlePaymentModel.paymentMethodData.info.invoiceNumber =
      this.invoiceNumber;
    googlePaymentModel.paymentMethodData.info.terminalId = this.terminalId;
    googlePaymentModel.paymentMethodData.info.orderId = this.orderId;

    googlePaymentModel.paymentMethodData.info.transactionSource =
      SourceComponent.PaymentForms;

    // Customer address
    googlePaymentModel.paymentMethodData.info.billingAddress =
      new GooglePayCustomerAddress();
    googlePaymentModel.paymentMethodData.info.billingAddress.streetAddress1 =
      this.customerAddress.StreetAddress1;
    googlePaymentModel.paymentMethodData.info.billingAddress.streetAddress2 =
      this.customerAddress.StreetAddress2;
    googlePaymentModel.paymentMethodData.info.billingAddress.city =
      this.customerAddress.City;
    googlePaymentModel.paymentMethodData.info.billingAddress.state =
      this.customerAddress.State;
    googlePaymentModel.paymentMethodData.info.billingAddress.postalCode =
      this.customerAddress.PostalCode;

    this.formEntry.Data = {
      ...this.formEntry.Data,
      GooglePayEmailAddress: gpayResponse.tokenization.email,
    };

    this.formioBuilderService.postUserDataEmbedForm(this.formEntry).subscribe(
      (res: number) => {
        if (this.customerSignature) {
          //save customer signature.
          this.invoiceService
            .uploadCustomersig({
              invoiceNumber: this.invoiceNumber,
              signatureUrl: this.customerSignature,
              createdBy: 1,
            })
            .subscribe((res) => {
              this.googlePayService.charge(googlePaymentModel).subscribe(
                (res: any) => {
                  this.transactionId = res.transactionId;
                  if (res) {
                    this.alertSuccess({
                      title: 'Success!',
                      text: 'Form and Payment has been successfully submitted!',
                    });
                  }
                },
                (err: any) => {
                  this.alertError({
                    title: `Payment failed!`,
                    text: `Please contact the merchant administrator.`,
                  });
                }
              );
            });
        } else {
          this.googlePayService.charge(googlePaymentModel).subscribe(
            (res: any) => {
              if (res) {
                this.alertSuccess({
                  title: 'Success!',
                  text: 'Form and Payment has been successfully submitted!',
                });
              }
            },
            (err: any) => {
              this.alertError({
                title: `Payment failed!`,
                text: `Please contact the merchant administrator.`,
              });
            }
          );
        }
      },
      (err) => {
        this.alertError({
          title: 'Unable to save Form',
          text: err.error,
        });
      }
    );
  }

  processACHPayment() {
    if (!this.achPaymentModel.AccountType) {
      this.achPaymentModel.AccountType = 0;
    }

    if (!this.achPaymentModel.CheckType) {
      this.achPaymentModel.CheckType = 0;
    }

    this.achPaymentModel.Amount = this.cardToken.amount;
    this.achPaymentModel.InvoiceNumber = this.invoiceNumber;
    this.achPaymentModel.TerminalId = 'MAIN';
    this.achPaymentModel.IsPartialPayment = false;
    this.achPaymentModel.Currency = 'USD';
    this.achPaymentModel.LocationId =
      this.locationComponentSelectedData.Id || this.cardToken.locationData.Id;
    this.achPaymentModel.CustomerId = this.customerId;
    this.achPaymentModel.StreetAddress1 = this.customerAddress.StreetAddress1;
    this.achPaymentModel.City = this.customerAddress.City;
    this.achPaymentModel.State = this.customerAddress.State;
    this.achPaymentModel.PostalCode = this.customerAddress.PostalCode;
    this.achPaymentModel.TransactionSource = SourceComponent.PaymentForms;
    this.achPaymentModel.SourceComponent = SourceComponent.PaymentForms;

    this.achPaymentService.achCharge(this.achPaymentModel).subscribe(
      (res: any) => {
        if (res) {
          this.transactionId = res.transactionId;
          if (this.customerSignature) {
            //save customer signature.
            this.invoiceService
              .uploadCustomersig({
                invoiceNumber: this.invoiceNumber,
                signatureUrl: this.customerSignature,
                createdBy: 1,
              })
              .subscribe((res) => {
                this.sendReceipt().then(
                  () =>
                    this.alertSuccess({
                      title: 'Success!',
                      text: 'Form and Payment has been successfully submitted!',
                    }),
                  (err) =>
                    this.alertService
                      .alertWarning({
                        title: `Payment Successful<br>Sending Receipt Failed`,
                        text: `The payment was done successfully.<br> Unfortunately, there was an error encountered
                      while sending the receipt.
                      <br><br>Please contact ${this.businessInfo.BusinessName} and request for the receipt to be sent to your email.`,
                      })
                      .then(() => {
                        this.scrollToTop();
                        (window as any).location.reload();
                      })
                );
              });
          } else {
            this.sendReceipt().then(
              () =>
                this.alertSuccess({
                  title: 'Success!',
                  text: 'Form and Payment has been successfully submitted!',
                }),
              (err) =>
                this.alertService
                  .alertWarning({
                    title: `Payment Successful<br>Sending Receipt Failed`,
                    text: `The payment was done successfully.<br> Unfortunately, there was an error encountered
                  while sending the receipt.
                  <br><br>Please contact ${this.businessInfo.BusinessName} and request for the receipt to be sent to your email.`,
                  })
                  .then(() => {
                    this.scrollToTop();
                    (window as any).location.reload();
                  })
            );
          }
        }
      },
      (err) => {
        this.alertError({
          title: `Payment failed!`,
          text: `Payment failed for invoice number: ${this.achPaymentModel.InvoiceNumber}`,
        });
      }
    );
  }

  sendReceipt(emailAddress?: string) {
    return new Promise((resolve, reject) => {
      // this.sendReceiptModel.To =
      //   emailAddress || this.paymentFormData?.customerData?.email;
      // this.sendReceiptModel.From = 'admin@paymenthq.com';
      // this.sendReceiptModel.PaymentMode = 'Card';
      // this.sendReceiptModel.AmountPaid = this.amount;
      // this.sendReceiptModel.Change = 0;
      // this.sendReceiptModel.StoreAddress = this.businessInfo.Address;
      // this.sendReceiptModel.StoreName = this.businessInfo.BusinessName;
      // this.sendReceiptModel.CommunicationType = CommunicationType.Email;
      // this.sendReceiptModel.TransactionId = this.transactionId;
      this.newSendReceiptModel.emailAddress =
        emailAddress || this.paymentFormData?.customerData?.email;
      this.newSendReceiptModel.mobileNumber = this.businessInfo.ContactNumber;
      this.newSendReceiptModel.paymentMethod =
        this.submissionData.heartlandpayment.paymentType === 'ach'
          ? 'ACH'
          : 'Card';

      this.invoiceService
        .getInvoicesByInvoiceNumber(this.invoiceNumber, true)
        .subscribe(
          (res: any) => {
            if (res) {
              this.sendReceiptModel.Invoice = res;
              this.creditService
                .getCashPaymentByInvoiceNumber(this.invoiceNumber)
                .subscribe(
                  (res2: any) => {
                    if (res2) {
                      this.sendReceiptModel.ReceiptNumber =
                        res2[res2.length - 1].receiptNumber;
                      this.newSendReceiptModel.receiptNumber =
                        res2[res2.length - 1].receiptNumber;

                      this.creditService
                        // .sendFormReceipt(this.sendReceiptModel) // to revert back
                        .newSendFormReceipt(this.newSendReceiptModel)
                        .subscribe(
                          (res3: any) => {
                            resolve('sent');
                            // Sending Receipt
                          },
                          (err) => {
                            reject(err.error);
                          }
                        );
                    }
                  },
                  (err) => {
                    reject(err.error);
                  }
                );
            }
          },
          (err) => {
            reject(err.error);
          }
        );
    });
  }

  setOrderAdjustments() {
    if (this.orderAdjustments.length > 0) {
      this.orderAdjustments.map((adjustment) => {
        adjustment = { ...adjustment, orderId: this.orderId };
        this.orderData.orderAdjustments.push(adjustment);
      });

      this.orderService.updateOrder(this.orderData).subscribe(
        (res: any) => {
          this.invoiceService
            .updateOrderInvoice(this.orderId, 'PaymentForm')
            .subscribe((res: any) => {});
        },
        (error: any) => {
          this.alertError({
            title: 'Saving order error!',
            text: 'Unable to set order adjustments.',
          });
        }
      );
    }
  }

  updateAmountTotal(eventData: any, event: any) {}
  processCardPayment() {}
  loadData(FormId: string) {}
  /**
   * This will do necessary adjustments of the parent Frame with its Height, width and title
   *
   */
  initializeFormAdjustments(form) {
    this.resizeFrame();
  }

  findCountryCode(data) {
    let countryCode = this.countriesWithCode.find(
      (country) => country.CountryCode === data
    );
    return countryCode ? countryCode.CountryCode2 : undefined;
  }

  loadCountriesCode() {
    this.busy = true;
    this.taxService
      .getAllCountries()
      .subscribe((response: any) => {
        if (response) {
          this.countriesWithCode = response;
        }
      })
      .add(() => {
        this.busy = false;
      });
  }

  ready(event, type?: string) {
    if (type && type === 'restoreForm') {
      this.currentForm.emit('resetForm');
    } else {
      this.currentForm = event.formio;
    }
  }

  getFormOptions() {
    const self = this;
    return {
      hooks: {
        beforeSubmit: function (submission, callback) {
          self.submissionCallback = callback;
          self.onSubmit(submission);
        },
      },
      submitMessage: '',
      disableAlerts: true,
      noAlerts: true,
    };
  }

  resizeFrame() {
    if ((window as any).embed) {
      new (window as any).embed.Child({});
    }
  }

  scrollToTop() {
    if ((window as any).embed) {
      const parent = (window as any).embed.Child({});
      parent.sendMessage('scrollToChildPos', 0);
    }
  }

  onSubmit(submission: any) {}
}
